import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function InvoicelinedetailContentReducer(state = initialState.invoicelinedetailContent, action: any) {
  switch (action.type) {
    case types.SAVE_INVOICELINEDETAILCONTENT_SUCCESS:
      return action.invoicelinedetailContent;
    default:
      return state;
  }
}
